const ShowResultsEnum = Object.freeze({
  Čeština: 'Zobrazit výsledky',
  Deutsch: 'Ergebnisse anzeigen',
  Français: 'Afficher les Résultats',
  Slovenčina: 'Zobraziť výsledky',
  Español: 'Mostrar resultados',
  English: 'Show Results',
})

export default ShowResultsEnum
